import React from "react";
import { reduxForm } from "redux-form";
import LocalPhoneOutlinedIcon from '@material-ui/icons/LocalPhoneOutlined';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import { connect } from "react-redux";

const mapState = (state) => {
    return {
        dispositivo: state.global.dispositivo,
    };
};

const mapDispatch = (dispatch) => {
    return {

        tagManager: (oDataTagManager) => {
            dispatch(oDataTagManager);
        }
    };
};

class ModalOpcionesAyuda extends React.Component {


    tagLinea = () => {
        this.props.tagManager({ "type": "EVENT_REGISTRO_BOTON_AYUDA_LINEAGNP", "dispositivo": this.props.dispositivo });
    }

    tagWhats = () => {
        this.props.tagManager({ "type": "EVENT_REGISTRO_BOTON_AYUDA_WHATSAPP", "dispositivo": this.props.dispositivo });
    }

    render() {
        return <div className="contenedor-btnO">
            <div className="contenedor-opcionesAyuda" >
                <div className="contenedor-opcion" >
                    <div className="text-opcion" >
                        <a className="txt-opcion" href="tel:5552279000" onClick={this.tagLinea.bind()} >
                            Línea GNP
                        </a>
                    </div>
                    <div className="icono-opcion">
                        <a href="tel:5552279000" onClick={this.tagLinea.bind(this)} className="a-btn">
                            <LocalPhoneOutlinedIcon
                                style={
                                    {
                                        height: "25px",
                                        width: "35px",
                                        color: "#FF6B0B",
                                    }

                                }
                            ></LocalPhoneOutlinedIcon>
                        </a>
                    </div>
                </div>
                <div className="contenedor-opcion" >
                    <div className="text-opcion">
                        <a className="txt-opcion opcion-whatsApp" onClick={this.tagWhats.bind(this)} >
                            WhatsApp
                        </a>
                    </div>
                    <div className="icono-opcion">
                        <a className="opcion-whatsApp a-btn" onClick={this.tagWhats.bind(this)}>
                            <WhatsAppIcon
                                style={
                                    {
                                        height: "25px",
                                        width: "35px",
                                        color: "#FF6B0B",
                                    }

                                }
                            ></WhatsAppIcon>
                        </a>
                    </div>
                </div>
            </div>

        </div>;
    }
}

ModalOpcionesAyuda = reduxForm({ form: "datosPassword" })(ModalOpcionesAyuda);
export default connect(mapState, mapDispatch)(ModalOpcionesAyuda);


// WEBPACK FOOTER //
// ./src/modal-ayuda/modal-opciones-ayuda.cmpt.js